/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RpConfigDTO
 */
export interface RpConfigDTO {
    /**
     * 
     * @type {string}
     * @memberof RpConfigDTO
     */
    clientId?: string;
    /**
     * 
     * @type {string}
     * @memberof RpConfigDTO
     */
    discoveryUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof RpConfigDTO
     */
    jwkUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof RpConfigDTO
     */
    redirectUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof RpConfigDTO
     */
    postLogoutRedirect?: string;
    /**
     * 
     * @type {string}
     * @memberof RpConfigDTO
     */
    certGroup?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RpConfigDTO
     */
    existsKeyGroup?: boolean;
}

export function RpConfigDTOFromJSON(json: any): RpConfigDTO {
    return RpConfigDTOFromJSONTyped(json, false);
}

export function RpConfigDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RpConfigDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'discoveryUrl': !exists(json, 'discoveryUrl') ? undefined : json['discoveryUrl'],
        'jwkUrl': !exists(json, 'jwkUrl') ? undefined : json['jwkUrl'],
        'redirectUrl': !exists(json, 'redirectUrl') ? undefined : json['redirectUrl'],
        'postLogoutRedirect': !exists(json, 'postLogoutRedirect') ? undefined : json['postLogoutRedirect'],
        'certGroup': !exists(json, 'certGroup') ? undefined : json['certGroup'],
        'existsKeyGroup': !exists(json, 'existsKeyGroup') ? undefined : json['existsKeyGroup'],
    };
}

export function RpConfigDTOToJSON(value?: RpConfigDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'clientId': value.clientId,
        'discoveryUrl': value.discoveryUrl,
        'jwkUrl': value.jwkUrl,
        'redirectUrl': value.redirectUrl,
        'postLogoutRedirect': value.postLogoutRedirect,
        'certGroup': value.certGroup,
        'existsKeyGroup': value.existsKeyGroup,
    };
}

